import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
  mainAccountDashboard: {
    analytics: [],
    appointments: [],
  },
  error: null,
  loader: false,
  featured: {},
  current_page: 1,
  per_page: PAGELENGTH
}

export const mainAccountDashboardSlice = createSlice({
  name: 'mainAccountDashboard',
  initialState: initialState,
  reducers: {
    setMainAccountDashboardAnalytic: (state, { payload }) => {
      state.mainAccountDashboard = payload?.data ?? payload;
    },
    setMainAccountDashboardAnalytics: (state, { payload }) => {
      state.mainAccountDashboard.analytics = payload;
    },
    setMainAccountDashboardAppointments: (state, { payload }) => {
        state.mainAccountDashboard.appointments = payload?.data;
        state.total = payload?.total;
        state.is_more = payload?.is_more;
        state.last_page = payload?.last_page;
        state.current_page = payload?.current_page;
        state.per_page = payload?.per_page
    },
    removerVendorReports: (state, { payload }) => {
      state.error = payload
    },
    clearAllMainAccountDashboard: (state, { payload }) => {
        state.loader = payload
    },
    setError: (state, { payload }) => {
        state.error = payload
    },
    setLoader: (state, { payload }) => {
        state.loader = payload
    },
  }
})


export const fetchMainAccountDashboardAnalytics = (params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {
      
      const result = await Api.fetchMainAccountDashboardAnalytics(params)
      if (result.status >= 200 && result.status < 300) {
          dispatch(setMainAccountDashboardAnalytics(result.data.data));
    }
    else if (result?.status == 422) {
        dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)
    
  }
  !disableLoader && dispatch(setLoader(false))
}



export const fetchMainAccountDashboardAppointments = (page, params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

      const result = await Api.fetchMainAccountDashboardAppointment(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        dispatch(setMainAccountDashboardAppointments(result.data.data));
      } else {
        dispatch(setMainAccountDashboardAppointments(result.data.data));
      }
    }
    else if (result?.status == 422) {
      dispatch(setError(result.data))
    }
  } catch (error) {
    console.log("error", error)

  }
  !disableLoader &&  dispatch(setLoader(false))
}




export const { setMainAccountDashboardAnalytics, clearAllMainAccountDashboard, setLoader, setError ,setMainAccountDashboardAppointments} = mainAccountDashboardSlice.actions

export default mainAccountDashboardSlice.reducer
export const MainAccountDashboardSelector = state => state.mainAccountDashboard



